import { gql } from "@apollo/client";
import { RealtimeInvoiceClientPageResult } from "../types/RealtimeInvoiceType";

export const GET_REALTIME_INVOICE_CLIENTS = gql`
    query GetRealtimeInvoiceClients(
        $settlementClientId: ID
        $page: Int!
        $size: Int!
    ) {
        getRealtimeInvoiceClients(
            settlementClientId: $settlementClientId
            page: $page
            size: $size
        ) {
            success
            code
            message
            content {
                settlementClientId
                channelId
                customerName
                availableInvoiceAmount
                currency
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export interface GetRealtimeInvoiceClientsResponse {
    getRealtimeInvoiceClients: RealtimeInvoiceClientPageResult;
}
